/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import api from './api/index'
// import * as types from './store/mutation'

Vue.use(Vuex);

export default new Vuex.Store({
  state:{
    backNoRefresh:false,//返回不刷新
    sendCodeStatus:false,//发送验证码状态
    getBackPassword:false,//找回密码  
    isNeedShowCode:false,//是否显示验证码
    btnLoading:false,//按钮loading
    bindPhoneStatus:false,//绑定手机状态  
  },
  mutations:{
    SAVE_PASSWORD_STATUS(state,res){
      Vue.set(state,'savePasswordStatus',!state.savePasswordStatus);
    },    
    BACK_NO_REFRESH (state, data) {
      Vue.set(state,'backNoRefresh',data)
    },    
    SEND_CODE_STATUS(state,res){    
      Vue.set(state,'sendCodeStatus',res);
    },  
    GET_BACK_PASSWORD(state,res){    
      Vue.set(state,'getBackPassword',res);
    },
    CHANGE_CODE_SHOW_STATUS(state,res){    
      Vue.set(state,'isNeedShowCode',!state.isNeedShowCode);
    },
    BTN_LOADING(state,res){
      Vue.set(state,'btnLoading',res);
    },
    GET_BIND_PHONE_STATUS(state,res){    
      Vue.set(state,'bindPhoneStatus',res);
    }, 
  },
  actions:{
    savePasswordStatus( {commit} ,data){  //保存修改密码状态
      return api.savePasswordStatus(data, (res) =>{
          commit('SAVE_PASSWORD_STATUS',res)
      })
    },
    sendCode( {commit} ,data){
      return api.sendCode(data, (res) =>{
        commit('SEND_CODE_STATUS',res);
      })
    },
    getBackPassword( {commit} ,data){
      return api.getBackPassword(data, (res) =>{
        commit('GET_BACK_PASSWORD',res);
      })
    },      
    getBindPhoneStatus( {commit} ,data){
      return api.getBindPhoneStatus(data, (res) =>{
        commit('GET_BIND_PHONE_STATUS',res);
      })
    },  
  },
  getters:{
    savePasswordStatus:state => state.savePasswordStatus,
    backNoRefresh: state => state.backNoRefresh,
    sendCodeStatus: state => state.sendCodeStatus,
    getBackPassword: state => state.getBackPassword,  
    isNeedShowCode: state => state.isNeedShowCode,
    btnLoading:state => state.btnLoading,//按钮loading
    bindPhoneStatus: state => state.bindPhoneStatus,
  },
});
